module.exports = __webpack_public_path__ + "static/img/new2.c319a561.png";